module.exports = __webpack_public_path__ + "static/media/bkey-logo.919ef006.svg";